<template>
        <div class="main">
                <div class="receiver-name">
                        <h4 class="text-center">{{this.friend.name}}</h4>
                </div>
                <div class="call-status">
                        <h5 class="text-center">{{this.callStatus}}</h5>
                </div>
                <div class="videocall-container" v-if="channel!=undefined">
                        <video-call :channel="channel" :uid="uid" :appId="appId" :videoProfile="videoProfile"
                                :token="token" v-on:userJoined="incrementJoined()" v-on:userLeft="decrementJoined()"
                                v-on:toggleChat="toggleChat()"></video-call>
                </div>
                <div class="show-button ">


                        <button v-if="joinedUsersCount<=1" title="Join Call" class="btn btn-primary btn-round" style="
                  z-index: 3;
                  border-radius: 50%;
                  margin: 0px;
                  padding: 10px;
                " @click.prevent="ringOthers">
                                <i class="material-icons" id="disable-camera"> call </i>
                        </button>
                </div>
                <div class="chat-container" v-if="showChat">
                        <single-chat :isInChat="true" :user="this.$route.params.friend"></single-chat>
                </div>
        </div>
</template>

<script>
        import constants from '../config/constants';
        import helper from '../mixins/helper';

        export default {
                data() {
                        return {
                                videoProfile: "720p_2",
                                appId: process.env.MIX_AGORA_APP_ID,
                                showChat: false,
                                joinedUsersCount: 1,
                                incomingCallListener: undefined,
                                currentCallListener: undefined,
                                callStatus: '',
                                friend: '',
                                channel: '',
                                uuid: '',
                                token: '',
                                isCaller: false,
                                audio: new Audio("/audio/caller.mp3"),
                                uid: window.auth_user.id,
                        };
                },

                async created() {
                        window.onbeforeunload = function (event) {
                                return confirm("Confirm refresh");
                        };
                        this.appId = constants.AGORA_APP_ID
                        if (!this.appId) {
                                return alert('Get App ID first!')
                        }
                        if (this.$route.params.uuid == undefined) {
                                this.$router.replace('/');
                                return;
                        }
                        console.log('route param uuid null vayena hai ta  ta');
                        this.friend = this.$route.params.friend;
                        this.channel = this.$route.params.channel;
                        this.uuid = this.$route.params.uuid;
                        this.token = this.$route.params.token;

                        this.isCaller = this.$route.params.wasIncoming || false;

                        this.updateNewCallStatusToBusy();
                        this.currentCallStatusListener();
                },
                beforeDestroy() {
                       
                        if (this.uuid == undefined) {
                        return;}
                        let call = {
                                callerName: window.auth_user.name,
                                callerPic: window.auth_user.img_url,
                                receiverName: this.friend.name,
                                receiverPic: this.friend.imageUrl,
                                callerId: window.auth_user.id,
                                receiverId: this.friend.id,
                                channelId: this.channel,
                                token: this.token,
                                uuid: this.uuid,
                        };
                        helper.eventLog(call, constants.eventTypes.leave_call);
                        database.ref().child(`calls`).child(window.auth_user.id).off('child_added', this
                                .incomingCallListener);
                        this.friend && database.ref().child(`calls`).child(this.friend.id).child(this.uuid).child(
                                'status').off('value', this.currentCallListener);
                        this.removeChannel();
                },
                methods: {
                        updateNewCallStatusToBusy() {
                                let $ = this;
                                let sessions = database.ref().child(`calls`).child(window.auth_user.id);
                                $.incomingCallListener = sessions.on("child_added", async (snap) => {
                                        let call = snap.val();
                                        if (
                                                call == null ||
                                                call == undefined ||
                                                call.status == "picked_up" ||
                                                call.status == "declined" ||
                                                call.channelId == undefined
                                        ) {
                                                return;
                                        } else if (call) {
                                                console.log('updated to busy', window.auth_user
                                                        .id, call.uuid);
                                                database
                                                        .ref()
                                                        .child(
                                                                `calls/${window.auth_user.id}/${call.uuid}`)
                                                        .child('status')
                                                        .set('busy');
                                        }

                                });

                        },
                        currentCallStatusListener() {
                                let $ = this;
                                this.currentCallListener = database.ref().child(`calls`).child($.friend.id).child($
                                        .uuid).child('status').on('value', (snap) => {
                                        if (snap.val() == 'busy') {
                                                $.callStatus = 'User is busy';
                                                setTimeout(() => {
                                                        if ($.callStatus ==
                                                                'User is busy') $
                                                                .callStatus = '';
                                                }, 5000);
                                                $.stopSound();
                                        } else if (snap.val() == 'ringing') {
                                                $.callStatus = 'Ringing...';

                                                $.playSound();
                                        } else if (snap.val() == 'picked_up') {

                                                $.callStatus = 'Picked Up';
                                                setTimeout(() => {
                                                        if ($.callStatus == 'Picked Up')
                                                                $.callStatus = '';
                                                }, 5000);
                                                $.stopSound()
                                        } else if (snap.val() == 'declined') {
                                                $.callStatus = 'Call Declined';
                                                setTimeout(() => {
                                                        if ($.callStatus ==
                                                                'Call Declined') $
                                                                .callStatus = '';
                                                }, 5000);
                                                $.stopSound()
                                        } else {
                                                $.stopSound();
                                        }
                                });
                        },
                        playSound() {
                                try {
                                        let $ = this;
                                        this.audio.addEventListener(
                                                "ended",
                                                function () {
                                                        $.audio.currentTime = 0;
                                                        $.audio.play();
                                                },
                                                false
                                        );
                                        this.audio.play();
                                } catch (e) {
                                        console.log(e);
                                        console.log('Error Playing Audio ')
                                }
                        },
                        stopSound() {

                                this.audio.pause();
                        },
                        toggleChat() {
                                this.showChat = !this.showChat;
                        },
                        ringOthers() {
                                let $ = this;
                                swal({
                                        title: 'Are you sure to ring ' + this.friend.name,
                                        buttons: ['No', 'Yes', ]
                                }).then((value) => {
                                        if (value) {
                                                $.isCaller = true;

                                                $.callStatus = 'Connecting..';

                                                let call = {
                                                        callerName: window.auth_user.name,
                                                        callerPic: window.auth_user.img_url,
                                                        receiverName: this.friend.name,
                                                        receiverPic: this.friend.imageUrl,
                                                        callerId: window.auth_user.id,
                                                        receiverId: this.friend.id,
                                                        channelId: this.channel,
                                                        token: this.token,
                                                        uuid: this.uuid,
                                                };
                                                axios
                                                        .post(
                                                                process.env.MIX_CALL_ENDPOINT,
                                                                call,
                                                        );
                                                helper.eventLog(call, constants.eventTypes
                                                        .initiate_call);
                                        }
                                });
                        },
                        incrementJoined() {
                                this.joinedUsersCount++;
                                this.stopSound();

                        },
                        decrementJoined() {
                                this.joinedUsersCount--;

                        },

                        removeChannel() {
                                database.ref().child(`calls`).child(this.friend.id).child(this.uuid).remove();

                                database.ref().child(`calls`).child(window.auth_user.id).child(this.uuid).remove();
                        }
                }
        };
</script>

<style scoped>
        .show-button {
                position: absolute;
                top: 10px;
                right: 10px;
        }

        .chat-container {
                position: absolute;
                top: 3px;
                background: white;
                height: calc(100%-80px);
        }

        .call-status {
                position: absolute;
                top: 50px;
                right: 10px;
                z-index: 9999;
                color: aliceblue;
        }
</style>